import * as React from "react";
const SvgTablerIconChartHistogram = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M2.5 2.5V17.5H17.5M16.6667 15V17.5M13.3333 13.3333V17.5M10 10.8333V17.5M6.66667 13.3333V17.5M2.5 9.16667C7.5 9.16667 6.66667 5 10 5C13.3333 5 12.5 9.16667 17.5 9.16667",
      stroke: "#181B25",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgTablerIconChartHistogram;
